var render = function render(){var _vm=this,_c=_vm._self._c;return _c('body',[(_vm.$UA() === 0)?_c('TempPC'):_c('TempH5')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }